export default {
    bgColor: 0x41f4ff,
    primaryKey: "BGElmnt_Str",
    secondaryKey: "BGElmnt_Cns",
    animateIn: (data, bg)=>{
        let image = bg.create(bg.scene.mid.x, bg.scene.mid.y, data.key);
        
        image.setScale(data.scaleX, data.scaleY);
        image.alpha = 0;
        image.setScale(0);
        image.angle = data.angle + (data.angle > 0 ? -30 : 30);
        image.setPosition(data.x, data.y);

        bg.scene.addTween(image, 700, {alpha: 1, scaleX: data.scaleX, scaleY: data.scaleY, angle: data.angle}, Phaser.Math.Easing.Sine.Out);
    },
    animateOut: (image, bg)=>{
        let deltaX = (image.x/bg.scene.size.width);
        bg.scene.addTween(image, 700, {scaleX: .5, scaleY: .5, alpha: 0, x: image.x + (350 * deltaX) + 200, y: image.y + (350 * deltaX) + 200}, Phaser.Math.Easing.Sine.Out);
    },
    data:[
        {
            key: "BGElmnt_Str",
            x: 486.2898134863702, y: 283.54662840746056,
            angle: 14,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnt_Str",
            x: 644.9583931133429, y: 399.609756097561,
            angle: 20,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnt_Str",
            x: -17.530846484935438, y: 322.52223816355814,
            angle: 2,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnt_Str",
            x: 49.951219512195124, y: 537.7101865136299,
            angle: 90,
            scaleX: -1,
            scaleY: 1
        },{
            key: "BGElmnt_Str",
            x: 381.0416068866571, y: 493.9196556671449,
            angle: 19,
            scaleX: 0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnt_Str",
            x: 217.43472022955524, y: 130.75466284074605,
            angle: -19,
            scaleX: 0.6999999999999997,
            scaleY: 0.6999999999999997
        },{
            key: "BGElmnt_Str",
            x: 874.5538020086084, y: 570.9698708751794,
            angle: -18,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnt_Str",
            x: 877.022955523673, y: 66.1119081779053,
            angle: -18,
            scaleX: 0.95,
            scaleY: 0.95
        },{
            key: "BGElmnt_Str",
            x: 482.9196556671449, y: 785.4906743185079,
            angle: 15,
            scaleX: 1,
            scaleY: 1
        },{
            key: "BGElmnt_Str",
            x: 773.3672883787661, y: 533.7101865136299,
            angle: -43.99999999999977,
            scaleX: -0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnt_Str",
            x: 423.64705882352945, y: 352.00430416068866,
            angle: -10.000000000000227,
            scaleX: -0.7999999999999998,
            scaleY: 0.7999999999999998
        },{
            key: "BGElmnt_Str",
            x: 984.8020086083214, y: 146.85365853658539,
            angle: -53.99999999999949,
            scaleX: -0.8499999999999999,
            scaleY: 0.8499999999999999
        },{
            key: "BGElmnt_Str",
            x: 768.3672883787661, y: 28.913916786226686,
            angle: 136.0000000000009,
            scaleX: 0.7499999999999998,
            scaleY: -0.7499999999999998
        },{
            key: "BGElmnt_Str",
            x: 487.635581061693, y: 93.49497847919656,
            angle: 110.00000000000091,
            scaleX: 0.7499999999999998,
            scaleY: -0.7499999999999998
        },{
            key: "BGElmnt_Str",
            x: 489.6972740315639, y: 596.4763271162124,
            angle: -70.99999999999824,
            scaleX: -0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnt_Str",
            x: 213.43472022955524, y: 634.674318507891,
            angle: 164.00000000000136,
            scaleX: -0.6999999999999997,
            scaleY: -0.6999999999999997
        },{
            key: "BGElmnt_Str",
            x: 985.7403156384505, y: 652.3041606886658,
            angle: 126.00000000000136,
            scaleX: 0.8499999999999999,
            scaleY: -0.8499999999999999
        },{
            key: "BGElmnt_Str",
            x: 54.58106169296987, y: 31.321377331420372,
            angle: 89.00000000000136,
            scaleX: -0.95,
            scaleY: 0.95
        },{
            key: "BGElmnt_Str",
            x: 54.58106169296987, y: 31.321377331420372,
            angle: 89.00000000000136,
            scaleX: -0.95,
            scaleY: 0.95
        },{
            key: "BGElmnt_Str",
            x: -19.886657101865126, y: 827.19368723099,
            angle: -177.99999999999864,
            scaleX: -1,
            scaleY: -1
        },{
            key: "BGElmnt_Str",
            x: 1009.3945480631278, y: 327.6700143472023,
            angle: -177.99999999999864,
            scaleX: -1,
            scaleY: -1
        },{
            key: "BGElmnt_Str",
            x: 385.2639885222382, y: -9.592539454806314,
            angle: 22,
            scaleX: 0.7499999999999998,
            scaleY: 0.7499999999999998
        },{
            key: "BGElmnt_Str",
            x: 142.06101694915253, y: 877.064406779661,
            angle: 0,
            scaleX: 0.7999999999999998,
            scaleY: 0.7999999999999998
        }
    ]
}